import { Alert, AlertDescription } from "frontend-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTriangleExclamation } from "@fortawesome/pro-regular-svg-icons";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { IssuesStatusItem } from "./IssuesStatusItem";
import { useIssuesStatusMetrics } from "./useIssuesStatusMetrics";

export type IssueStatusData = {
    status: string;
    apiKey: string;
    count: number;
    percentage: number;
};

export function IssuesStatusList() {
    const { t } = useTranslation();
    const { statusListData, isLoading, error } = useIssuesStatusMetrics();

    const statusData = useMemo(() => {
        return statusListData.map((status) => ({
            status: t(status.translationKey),
            apiKey: status.apiKey,
            count: status.count,
            percentage: status.percentage,
        }));
    }, [statusListData, t]);

    if (error) {
        return (
            <div className="px-5 py-4">
                <Alert variant="error">
                    <FontAwesomeIcon icon={faTriangleExclamation} className="text-chameleon-pink" />
                    <AlertDescription>
                        {t("common.errorLoadingData")}: {error.message}
                    </AlertDescription>
                </Alert>
            </div>
        );
    }

    if (!isLoading && statusData.length === 0) {
        return (
            <div className="text-text-muted px-5 py-8 text-center text-label">
                {t("dashboard.noIssuesFound")}
            </div>
        );
    }

    return (
        <div className="divide-compendia-border divide-y">
            {statusData.map((item, index) => (
                <IssuesStatusItem
                    key={isLoading ? index : item.status}
                    status={item.status}
                    statusKey={item.apiKey}
                    count={item.count}
                    percentage={item.percentage}
                    isLoading={isLoading}
                />
            ))}
        </div>
    );
}
